import types from '../../actions/types'
import {combineReducers} from 'redux'
import {get, isNil} from 'lodash'

export const isVisible = (state = false, action) => {
  switch (action.type) {
    case types.PRICE_LISTS_SHOW_PART_CATEGORY_DIALOG:
      return true
    case types.PRICE_LISTS_HIDE_PART_CATEGORY_DIALOG:
      return false
    default:
      return state
  }
}

export const isEditing = (state = false, action) => {
  switch (action.type) {
    case types.PRICE_LISTS_SHOW_PART_CATEGORY_DIALOG:
      return action.isEditing
    case types.PRICE_LISTS_HIDE_PART_CATEGORY_DIALOG:
      return false
    default:
      return state
  }
}

export const partCategoryToEdit = (state = null, action) => {
  switch (action.type) {
    case types.PRICE_LISTS_SHOW_PART_CATEGORY_DIALOG:
        const category = action.category
        const subCategory = get(category, 'category', null)

      return action.isEditing
          ? !isNil(subCategory) ? subCategory : category
          : null
    case types.PRICE_LISTS_HIDE_PART_CATEGORY_DIALOG:
      return null
    default:
      return state
  }
}

export default combineReducers({
  isVisible,
  isEditing,
  partCategoryToEdit,
})